// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"46d39176","281":"1a301838","407":"0a805555","544":"660feedc","760":"5b7cc92f","787":"65d2dea1","788":"b7aee0e6","959":"60a7e91e"}[chunkId] + ".chunk.js";
};